import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";

import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaBriefcase, FaGift, FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaListAlt,
  FaRegCreditCard,
  FaWpforms,
  FaRegCheckCircle,
  FaFileAlt,
  FaUserCheck,
  FaShippingFast,
} from "react-icons/fa";
import {
  FaMedal,
  FaRegHandshake,
  FaHotel,
  FaReceipt,
  FaLayerGroup,
  FaGlobeAmericas,
  FaPhoneAlt,
  FaUtensils,
  FaGasPump,
} from "react-icons/fa";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaTags,
} from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const Premium = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Premium")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "What is the typical annual fee for a premium credit card?",
      answer:
        " Premium cards usually charge annual fees ranging from ₹3,000 to ₹25,000, depending on the issuer and the benefits offered. Some cards waive the fee on reaching annual spend thresholds.",
    },
    {
      question:
        " Do all premium credit cards offer unlimited airport lounge access?",
      answer:
        " Most premium cards offer unlimited access to airport lounges under Visa Infinite, Mastercard World Elite, or Priority Pass programs, though a few may have monthly caps.",
    },
    {
      question: "Are premium credit cards worth it?",
      answer:
        " Yes, if you frequently travel, dine, or shop for luxury goods. The value derived from rewards, exclusive services, and convenience can easily surpass the cost.",
    },
    {
      question:
        " Can I get a premium credit card with an average credit score?",
      answer:
        " Typically, premium cards require a credit score of 750+. Applicants with lower scores may be rejected or offered lower-tier cards.",
    },
    {
      question: " Are foreign transaction charges lower on premium cards?",
      answer:
        "Yes, many premium credit cards offer reduced forex markups (1.5%-2.0%) compared to standard cards (3.5%), making them ideal for international transactions.",
    },
    {
      question: "  Does TheFinMaster issue premium credit cards?",
      answer:
        "  No. TheFinMaster.com does not issue credit cards. We provide comprehensive comparisons, educational content, and application redirection to the bank’s official site for a seamless experience.",
    },
    {
      question: "Are the travel and lifestyle benefits applicable globally?",
      answer:
        "  Yes, the benefits often apply internationally, especially with globally recognized networks like Visa Infinite and Mastercard World Elite.",
    },
    {
      question: "  Can premium credit cards help build credit?",
      answer:
        "  Absolutely. Responsible usage of a premium card can positively impact your credit score, as long as payments are made on time and within credit limits.",
    },
    {
      question: "Do premium credit cards offer concierge services?",
      answer:
        "Yes, most premium credit cards come with 24/7 concierge services to assist with travel bookings, dining reservations, gift deliveries, and event access, offering a high level of personal convenience.",
    },
    {
      question:
        "Can I get complimentary golf access with a premium credit card?",
      answer:
        "Many premium cards offer free or discounted access to golf courses across India and even internationally. These privileges are usually limited to a few rounds per year and may require prior booking.",
    },
    {
      question:
        "Do premium credit cards offer higher reward points on spending?",
      answer:
        "Absolutely. Premium cards generally offer accelerated rewards on specific categories like dining, travel, fuel, or international spends, making them ideal for high spenders.",
    },
    {
      question:
        "Are premium credit cards linked to elite memberships or loyalty tiers?",
      answer:
        "Yes, some premium cards come bundled with elite hotel loyalty memberships, airline frequent flyer status, or special tie-ups with lifestyle and retail brands that offer exclusive privileges.",
    },
    {
      question: "Is insurance coverage included in premium credit cards?",
      answer:
        "Most premium credit cards offer complimentary insurance such as air accident cover, lost baggage insurance, and medical emergency coverage during travel. Limits and terms vary by issuer.",
    },
    {
      question: "What income is required for a premium credit card?",
      answer:
        "The income eligibility for premium credit cards typically ranges from ₹10 lakhs to ₹25 lakhs annually. Some cards may also consider high credit scores and past spending patterns for approval.",
    },
    {
      question: "Can I get cashback benefits on premium credit cards?",
      answer:
        "While premium cards focus more on travel and luxury perks, many also offer cashback on select categories like groceries, utility bills, or fuel. However, these are usually capped or part of specific offers.",
    },
    {
      question: "Are premium credit cards safer for international travel?",
      answer:
        "Yes, they often come with enhanced security features, real-time fraud detection, EMV chip technology, and global customer support, making them more secure and travel-friendly.",
    },
    {
      question: "Do premium cards offer EMI on large purchases?",
      answer:
        "Most premium cards allow you to convert high-value transactions into EMIs at attractive interest rates, helping with better financial planning without compromising on lifestyle.",
    },
    {
      question: "Can I upgrade my existing card to a premium one?",
      answer:
        "Yes, banks often allow you to upgrade to a premium card if you meet the spending or credit profile criteria. Some may even offer upgrade offers based on your payment history and usage pattern.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const steps = [
    {
      icon: <FaFileAlt className="h-6 w-6 text-blue-600" />,
      title: " Upload Necessary Documents",
      description:
        " Submit KYC, income proof, and any additional documentation required.",
    },
    {
      icon: <FaWpforms className="h-6 w-6 text-amber-500" />,
      title: "Fill in the Application Form",
      description:
        " Complete the online form with your personal, financial, and employment details.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-purple-600" />,
      title: "Explore and Compare",
      description:
        " Head over to TheFinMaster.com to evaluate the best premium credit cards offered by top banks based on benefits, fees, and eligibility criteria.",
    },
    {
      icon: <FaRegCreditCard className="h-6 w-6 text-teal-500" />,
      title: "Choose the Ideal Card ",
      description:
        " Pick a card that fits your lifestyle—be it travel-focused, luxury-oriented, or high-reward centric.",
    },

    {
      icon: <FaRegCheckCircle className="h-6 w-6 text-pink-500" />,
      title: "Check Eligibility Criteria",
      description:
        " Premium cards often come with stringent income or spending requirements. Verify these before applying.",
    },

    {
      icon: <FaFileAlt className="h-6 w-6 text-green-500" />,
      title: "Verification Process",
      description:
        " The issuing bank will review your credentials and perform background checks.",
    },
    {
      icon: <FaShippingFast className="h-6 w-6 text-orange-500" />,
      title: " Approval & Delivery",
      description:
        "  Once approved, your Premium Credit Card will be delivered within 5–10 business days.",
    },
  ];
  const benefits = [
    {
      icon: <FaMedal className="text-3xl text-amber-600" />,
      title: "  Global Lounge Access",
      description:
        " Enjoy complimentary access to plush domestic and international lounges with gourmet food, free Wi-Fi, showers, and guest privileges—ideal for luxury and business travellers.",
    },

    {
      icon: <FaRegHandshake className="text-3xl text-purple-600" />,
      title: "Concierge Services",
      description:
        " Get 24/7 access to concierge services for travel bookings, event reservations, dining, and emergencies. It’s like having a personal assistant on call for your lifestyle needs.",
    },
    {
      icon: <FaHotel className="text-3xl text-yellow-500" />,
      title: " Luxury Travel & Hotel Perks",
      description:
        " Unlock elite benefits at luxury hotels such as free upgrades, late check-outs, and special discounts through global tie-ups like Amex FHR or Visa Luxury Hotel Collection.",
    },
    {
      icon: <FaReceipt className="text-3xl text-pink-500" />,
      title: "Reward Multipliers",
      description:
        " Earn 3X–10X points on premium spending like flights, dining, and international transactions. Accumulate rewards faster and enjoy high-value redemptions for travel and shopping.",
    },

    {
      icon: <FaLayerGroup className="text-3xl text-green-600" />,
      title: "Comprehensive Insurance Coverage",
      description:
        " Access a broad coverage umbrella—international travel insurance, lost baggage, medical emergencies, air accident cover—ensuring peace of mind wherever you go.",
    },

    {
      icon: <FaGlobeAmericas className="text-3xl text-red-500" />,
      title: "  Golf & Lifestyle Privileges",
      description:
        "  Enjoy complimentary rounds at premium golf courses, spa access, curated dining events, and invites to exclusive gatherings tailored for affluent cardholders.",
    },
    {
      icon: <FaPhoneAlt className="text-3xl text-blue-500" />,
      title: "  Priority Customer Service",
      description:
        " Service Premium cards offer dedicated support with priority helplines and relationship managers to ensure fast resolution, account handling, and personalized attention.",
    },
    {
      icon: <FaUtensils className="text-3xl text-indigo-500" />,
      title: "  Fuel Surcharge Waiver & Dining Discounts",
      description:
        "   While not the main feature, many premium cards provide fuel surcharge waivers and fine dining deals to add everyday value to your elite lifestyle experience.",
    },
  ];

  const factors = [
    {
      icon: FaMoneyCheckAlt,
      title: "Annual Fees vs. Benefits",
      desc: "  Premium credit cards come with high annual and joining fees—often between ₹3,000 to ₹25,000 or more. It's important to evaluate whether the rewards, travel perks, and exclusive services justify the cost. Cards that offer annual fee waivers on high yearly spends may present better long-term value.",
    },
    {
      icon: FaLayerGroup,
      title: " Reward Redemption Ecosystem",
      desc: "  Ensure the rewards earned on your premium card can be redeemed in ways that suit your lifestyle. Look for cards that offer flexibility to redeem points for airline miles, hotel bookings, luxury merchandise, gift vouchers, and even statement credits. A seamless and transparent redemption process can significantly increase the utility of your accumulated points.",
    },

    {
      icon: FaClipboardCheck,
      title: "International Acceptance & Forex Markups",
      desc: " If you’re a frequent traveler or shop online from international platforms, check whether your premium card is widely accepted globally. Also, look at the foreign transaction markup fees—lower markups (1.5%-2.5%) help you save significantly on international spends compared to standard cards that typically charge 3.5%.",
    },
    {
      icon: FaBalanceScale,
      title: "Luxury Travel Partnerships",
      desc: " Premium cards usually have partnerships with elite travel brands like Emirates, Taj Hotels, Marriott, or American Express Travel. These alliances translate into better value via discounts, exclusive offers, reward point boosters, or access to members-only privileges. Choose a card whose partnerships align with your travel preferences.",
    },
    {
      icon: FaWallet,
      title: "Eligibility Thresholds",
      desc: "  Most premium cards have strict eligibility criteria, including a high monthly income or annual ITR filing, excellent credit scores, and consistent repayment history. Before applying, ensure you meet the bank’s parameters to avoid unnecessary rejection that may impact your credit score.",
    },
    {
      icon: FaTags,
      title: "Concierge and Lifestyle Perks",
      desc: "  The quality of concierge services and lifestyle benefits can vary significantly between cards. Look for cards that provide all-encompassing services—travel planning, health and wellness support, curated gifting, and personal event planning. A strong concierge service adds significant value, especially for users with a busy schedule or frequent luxury needs.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Best Premium Credit Cards in India 2024 - Exclusive Benefits
        </title>
        <meta
          name="description"
          content="Best Premium Credit Cards in India - Check Best Premium Credit Cards Available in India. Compare & Apply now for the Most Prestigious with Benefits."
        />
        <meta
          name="keywords"
          content="premium credit cards, american express platinum charge card, axis bank premium credit card, sbi premium credit card, hdfc bank premium credit card, icici bank premium credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/best-premium-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Premium Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
            <Link
                      to="/credit-card/reward-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaGift className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Reward
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/business-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Business
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/lifestyle-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                          LifeStyle
                        </span>
                      </span>
                    </Link>
        </div>
        <h2 className="text-center font-bold text-2xl md:text-3xl  my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[350px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                <h2 className="text-center font-medium pt-5 text-lg">
                                                  <span className="font-semibold text-white">816 people</span>{" "}
                                                  are on call with our advisors right now
                                                </h2>
                                              </div> */}
              <div className="w-full mx-auto">
                {/* <Link
                  to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                  <div className="w-[80%] mx-auto ">
                  <AdBanner displayOrder="2" />
                  </div>
                {/* </Link> */}
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                    Know your advisor
                                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl  font-bold text-gray-800 ">
            What is a Premium Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A Premium Credit Card is designed for high-net-worth individuals who
            seek exclusive privileges, unparalleled rewards, and elevated
            lifestyle experiences. These cards go beyond basic functionalities
            by offering luxury travel benefits, concierge services, high credit
            limits, global acceptance, and premium access to airport lounges,
            golf courses, and elite events. Premium credit cards cater to
            individuals who prioritize not just convenience but a statement of
            status, lifestyle enhancement, and top-tier financial flexibility.
            With added features like complimentary insurance, reward
            multipliers, and personalized customer care, premium cards represent
            the pinnacle of credit card offerings.
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply for a Premium Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a Premium Credit Card is an easy yet
          eligibility-dependent process. Here's how to go about it:
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
        </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl  font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for a Premium Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  PAN Card and Aadhaar Card (KYC)
                </span>
                {/* <span> PAN card, Aadhaar card, or passport.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Latest 3–6 months bank statement
                </span>
                {/* <span> Utility bills, rental agreement, or Aadhaar card.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Income proof (Salary slips or ITR)
                </span>
                {/* <span>  Latest salary slips (for salaried individuals), ITR or bank statements (for self-employed).
                    </span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Passport-size photographs
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Address proof (Utility bill, Passport, etc.)
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Eligibility to Get a Premium Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Minimum age of 21 years (salaried) or 25 years (self-employed)
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Minimum monthly income (varies by card, typically ₹30,000+)
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Monthly income of ₹75,000 or above, or ITR exceeding ₹10 lakhs
                  annually{" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Good to excellent credit score (750+ preferred)
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span className="block  text-gray-800 dark:text-white">
                  Consistent financial history and strong repayment record
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-2xl md:text-3xl  font-semibold text-gray-800 text-center mb-10">
          Benefits of a Premium Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl  font-bold text-gray-900 text-center mb-6">
          Key Factors to Consider While Choosing the Best Premium Credit Card{" "}
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Why Opt for a Premium Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
          Premium credit cards are ideal for individuals who value luxury,
          travel frequently, or want to access top-tier services globally. If
          you spend heavily on travel, hospitality, or luxury goods, a premium
          card provides unmatched savings, comfort, and exclusivity. It's also a
          fit for those who prioritize convenience and quick dispute resolution
          through elite customer support. Professionals, entrepreneurs, global
          travelers, and high-income individuals often find immense value in
          these cards due to their holistic offering that enhances both
          financial and lifestyle experiences.
        </p>

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl  font-semibold text-center mb-8">
          Premium Credit Card vs Normal Credit Card: A Comparative Snapshot
        </h3>
        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Eligibility",
                  "High income & credit score",
                  "Moderate requirements",
                ],
                ["Fees", "High joining/renewal fees", "Low to moderate"],
                [
                  "Rewards",
                  "High reward rate, luxury-focused",
                  "Standard cashback or reward points",
                ],
                [
                  "Lounge Access",
                  "Complimentary global access",
                  "Limited or no access",
                ],
                ["Concierge", "Available", "Not available"],
                [
                  "Insurance Coverage",
                  "Extensive international coverage",
                  "Basic or none",
                ],
                ["Credit Limit", "Very High", "Moderate"],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">
                        Premium Credit Card:
                      </span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Normal Credit Card:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Premium Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Normal Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Eligibility",
                      "High income & credit score",
                      "Moderate requirements",
                    ],
                    ["Fees", "High joining/renewal fees", "Low to moderate"],
                    [
                      "Rewards",
                      "High reward rate, luxury-focused",
                      "Standard cashback or reward points",
                    ],
                    [
                      "Lounge Access",
                      "Complimentary global access",
                      "Limited or no access",
                    ],
                    ["Concierge", "Available", "Not available"],
                    [
                      "Insurance Coverage",
                      "Extensive international coverage",
                      "Basic or none",
                    ],
                    ["Credit Limit", "Very High", "Moderate"],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Premium;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link, useLocation } from 'react-router-dom'
// const Premium = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);

//     const location = useLocation();
//     const cardData = location.state;
//     console.log(cardData, location.state)
//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     console.log({indexOfLastCard,indexOfFirstCard})
//     console.log({cardData})
//     const currentCards = Array.isArray(cardData) && cardData.filter((cards)=>cards.category_name==="Premium").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})
//     // const currentCards = CreditCardData.cards?.filter((card)=>card.category_name==="Premium").slice(indexOfFirstCard, indexOfLastCard);
//     // console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Premium Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} cardDetails={item} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default Premium
